import React from 'react';
import { useHistory } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import EmailTemplate from './EmailTemplate';
import api from '../../../api';
import '../../../styles/details.scss';
import { INotificationTemplateItem, ICreateTemplate } from '../../../core';

const AddEmailForm: React.FunctionComponent<{
  onClose?: () => void;
  isEdit: boolean;
  template?: INotificationTemplateItem;
  key: string;
  subject: string;
  realod?: () => void;
}> = (props) => {
  const history = useHistory();

  const onSubmit = async (data: any) => {
    const updateData: ICreateTemplate = {
      key: props.key,
      messageTemplate: data.messageTemplate.toString('html'),
      subject: data?.subject,
      isActive: props.template?.isActive || false,
    };

    try {
      await api.settings.updateTemplateContent(
        'email',
        props.template?._id || '',
        updateData
      );
      props.onClose?.();
      props.realod?.();
      toastr.success('Success', 'Email template saved successfully');
    } catch (error) {
      if (error?.response?.data?.data?.message) {
        toastr.error('Error', error?.response?.data?.data?.message.join());
      } else {
        toastr.error('Error', error?.response?.data?.message);
      }
    }
  };

  return (
    <>
      <div className="detail-poupup bg-white position-fixed top-0 w-100 h-100 overflow-auto in">
        <div className="container-fluid bg-gray-100 border-bottom py-3 position-sticky top-0 zIndex-9">
          <div className="row align-items-center">
            <div className="col-auto" onClick={props.onClose}>
              <i className="icon-close text-gray-500 font-xxl cursor-pointer"></i>
            </div>
            <div className="col">
              <h5 className="mb-0">Update {props.subject}</h5>
            </div>

            <div className="col-auto mt-md-0 mt-1"></div>
          </div>
        </div>

        <div className="container-fluid px-0 ch-100">
          <div className="row no-gutters h-100 bg-gray-100">
            <EmailTemplate
              isEdit={props.isEdit}
              templateDetails={props.template}
              onSubmit={onSubmit}
            ></EmailTemplate>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default AddEmailForm;
